/** Map only the agent's structured carrier enum. Labels are presentation-only. */
export function chipTypeForCarrier(carrier) {
    switch (carrier) {
        case 'MifareUltralightAes': return 'mifare_ultralight_aes';
        case 'MifarePlusEv2_2K': return 'mifare_plus_ev2';
        default: return undefined;
    }
}
//# sourceMappingURL=types.js.map